import script from "./PaywallInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallInfo.vue?vue&type=script&setup=true&lang=js"

import "./PaywallInfo.vue?vue&type=style&index=0&id=a003f220&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a003f220"]])

export default __exports__